export const DEMO_ALLOWED_SELECTOR = [
  '.right-panel',
  '.MuiAccordionSummary-root',
  '.MuiTab-root',
  '.MuiSelect-select',
  '.MuiMenuItem-root',
  '[role="combobox"]',
  '[role="option"]',
  '.summary-calculator__sorting',
  '[data-demo-allowed="header"]',
  '[data-demo-allowed="player"]',
  '[data-demo-allowed="hero-category"]',
  '[data-demo-allowed="products-table"]',
  '[data-demo-allowed="informer"]',
  '[data-demo-allowed="registration"]',
  '[data-demo-allowed="save-product"]',
  '[data-demo-allowed="delivery-search"]',
  '[data-demo-allowed="delivery-route"]',
  '[data-demo-allowed="next-step"]',
  '.customs-declaration__title-row',
].join(', ')

export const DEMO_RESTRICTED_SELECTOR = [
  'button',
  'a',
  'input',
  'form',
  'textarea',
  '[role="button"]',
].join(', ')

export const DEMO_INTERACTION_EVENTS = [
  'click',
  'focusin',
  'keydown',
  'pointerdown',
  'submit',
]

